module.exports = __webpack_public_path__ + "static/media/C label.05124dd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/C label.png
// module id = 979
// module chunks = 0